import { GlSkeletonLoader } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'LoadingStateListItem',
    components: {
        GlSkeletonLoader
    },
    props: {
        leftLinesCount: {
            type: Number,
            required: false,
            default: 2
        },
        rightLinesCount: {
            type: Number,
            required: false,
            default: 2
        }
    }
};
